import React, { useEffect, useState } from "react";
import { getImageUrl, teamLeagueInfoUrl } from "../../utils/generalLiveCenter";
import { loadStyles } from "../../utils/cssLoader";
import NextImage from "../common/NextImage";
import NoDataFound from "../common/NoDataFound";

const BasketballMatchTable = ({
  data,
  loadCSS = true,
  dataClient = false,
  title,
  sport = "basketball",
  websiteBaseUrl,
  dataPath,
}) => {
  const [clientData, setClientData] = useState(null);

  useEffect(() => {

    if (!dataClient) return;

    const container = document?.querySelector(".microservice-cont");
    const raw = container?.getAttribute("data-listingdata");
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw)?.data?.data;
      setClientData(parsed || null);
    } catch (err) {
      console.error("Failed to parse data-listingdata:", err);
    }
  }, [dataClient]);

  useEffect(() => {
    if (loadCSS) {
      loadStyles("leaguestandings");
    }
  }, [loadCSS]);

  const tableData = dataClient ? clientData : data;
  if (!tableData?.length) {
    return <NoDataFound />;
  }

  return (
    <div className="global_table standing_table rugby">
      {title && <h1>{title}</h1>}
      <table>
        <thead>
          <tr>
            <th>#</th>
            <th>
              <span>Teams</span>
            </th>
            <th>P</th>
            <th>W</th>
            <th>L</th>
            <th>D</th>
            <th>FORM</th>
          </tr>
        </thead>
        <tbody>
          {tableData?.map((t, index) => (
            <tr key={index}>
              <td>{t?.pc}</td>
              <td>
                <a
                  href={teamLeagueInfoUrl({
                    dataClient,
                    websiteBaseUrl,
                    dataPath,
                    category: "team",
                    sport,
                    name: t?.nm || t?.team?.nm,
                    id: t?.team_id || t?.team?.id,
                  })}
                  className="team_name"
                >
                  <div className="bolar_team">
                    <div className="ico_flag">
                      <NextImage
                        src={getImageUrl("", "", sport, t?.team_id || t?.team?.id)}
                        width={22}
                        height={22}
                      />
                    </div>
                    <span className="name">{t?.nm || t?.team?.nm}</span>
                  </div>
                </a>
              </td>
              <td>{t?.pl}</td>
              <td>{t?.wo}</td>
              <td>{t?.lo}</td>
              <td>{t?.dr}</td>
              <td>
                <ul className="prev_match_status">
                  {t?.lfm?.map((w, idx) => (
                    <li
                      key={idx}
                      className={`${w === "W" ? "win" : w === "L" ? "loss" : "draw"}`}
                    >
                      {w}
                    </li>
                  ))}
                </ul>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default BasketballMatchTable;
